var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 66",
    style: {
      enableBackground: "new 0 0 75 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,31.2c0.8,0.8,1.2,1.7,1.2,2.8V64c0,1.8,2.5,2.7,4,1.5l9.5-9.6c1.3-1.3,2-2,2-3.3V34c0-1,0.4-2,1.2-2.8L73.8,5.1 c2.1-2,0.5-5.1-2.6-5.1H3.7c-3,0-4.6,3.2-2.6,5.1L28.5,31.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fc3820c3ff6bb5870f0ab9636129985d.svg";
export { ForwardRef as ReactComponent };